import { StrictMode, type ReactNode } from 'react';

import { Toaster } from '@/shared/components/ui/Toaster';
import { SupportDialogHost } from '@modules/support';

import { AuthProvider } from './AuthProvider';
import { I18nProvider } from './I18nProvider';
import { ThemeProvider } from './ThemeProvider';
import { UrqlProvider } from './UrqlProvider';

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <StrictMode>
      <ThemeProvider>
        <I18nProvider>
          <UrqlProvider>
            <AuthProvider>
              {children}
              <Toaster />
              <SupportDialogHost />
            </AuthProvider>
          </UrqlProvider>
        </I18nProvider>
      </ThemeProvider>
    </StrictMode>
  );
}
